module.exports = __webpack_public_path__ + "static/media/small-truck.6a699415.webp";